import React, { useEffect, useState } from 'react';
import Routes from './routes';
import TagManagerService from 'services/TagManager';
import CurtainService from 'services/Curtain';
import { Helmet } from 'react-helmet';
import PubSub from 'services/PubSub/';
import ErrorBoundary from "components/ErrorBoundary";
import Log from "services/Log";
import LoginService from "services/Login/";
import StorageService from 'services/StorageService/';
import ServiceWorker from 'services/ServiceWorker';
import CartAction from 'actions/Cart';
import CmsService from 'services/CMS';
import BrowserSupport from 'services/BrowserSupport';
import Curtain from 'pages/Curtain';
import BrowserUpdate from 'pages/BrowserUpdate';
import { version } from 'config';
import { createTab, removeTab, updateTabChange} from 'utils';
import productsStore from 'stores/new/Products';
import styles from './scss/styles.scss';//NOSONAR

window.tabId = createTab();

const App = () => {

    const [browserSupport, setBrowserSupport] = useState(true);
    const [curtain, setCurtain] = useState(true);
    const [curtainData, setCurtainData] = useState(null);

    useEffect(() => {
        setBrowserSupport(BrowserSupport.verifyBrowserSupport());
        CurtainService.init();
        TagManagerService.init();
        ServiceWorker.init();
        Log.init();

        verifyCurtain();

        try{
            if(window && window.__renderData && typeof(window.__renderData) == 'string'){
                window.__renderData = JSON.parse(window.__renderData);
            }
        }catch(e){
            /* eslint-disable no-console */
            console.log("Error Parse render data");
            /* eslint-enable no-console */
        }


        window.onresize = () => {
            PubSub.dispatch('window_on_resize');
        };

        window.onbeforeunload = () => {
            removeTab();
        }

        window.onfocus = () => {
            updateTabChange();
        }

        validateSession();
        setInterval(validateSession,(15 * 60 * 1000));

    },[])


    const validateSession = () => {
        const sessionExpired = StorageService.getItem('expiration-session');
        if(sessionExpired){
            StorageService.removeItem('expiration-session');
            setTimeout(() => {
                PubSub.dispatch('open_snackbar',{
                    titleButtonMobile: 'Ingresa',
                    titleButtonDesktop: 'Ingresa',
                    TitleMobile: '¡Tu sesión ha expirado!',
                    TitleDesktop: `¡Hola ${sessionExpired}, tu sesión ha expirado!`,
                    Subtitle:'Ingresa nuevamente a tu cuenta',
                    timer: 15000,
                    type: 'userSession',
                    callback : ()=>{
                        PubSub.dispatch('login_open');
                    }
                });
            },0);
        }

        LoginService.jwtLogged().then(results => {
            if(!results){
                const userData = StorageService.getSecureItem('userData');
                if(LoginService.logout() && window){
                    StorageService.setItem('expiration-session', userData.firstName);
                    CartAction.logout(()=> { window.location.reload() });
                }
            }
        });
    }

    const _formatVerision = (text) => {
        return text.replace(/\./g,'');
    }

    const verifyCurtain = () => {
        try{
            const isDevelopment = PROJECT_ENV.authDevelopment;
            const isProduction = window && window.location && window.location.href.indexOf('jumbo.cl') !== -1;

            CmsService.getVersion().then(data => {
                const apiVersion = _formatVerision(data.acf.content[0].version);
                const jsVersion = _formatVerision(version);

                if(window && (apiVersion > jsVersion)){
                    window.location.reload(true);
                }
            });

            if(!isDevelopment && isProduction) {
                CmsService.getHome(11484, 'curtain', 'curtain').then(results => {
                    if (!(results && results.acf && !Array.isArray(results.acf) && results.acf.content[0] && results.acf.content[0].active)) {
                        setCurtain(false);
                        return false;
                    }

                    const content = results.acf.content[0];

                    setCurtainData(content)
                    setCurtain(true);
                });
            } else {
                setCurtain(false);
            }

        } catch (e) {
            /* eslint-disable no-console */
            console.log(e);
            /* eslint-enable no-console */
            setCurtain(false)
        }
    }

    if(!browserSupport) return <BrowserUpdate />;
    if(curtain) return  <Curtain content={curtainData} />;


    return (

        <div>
            <Helmet>
                <title>Jumbo.cl</title>
                <meta name="description" content="El supermercado online de Chile con la mayor variedad de productos y las mejores opciones de despacho. Encuentra ofertas y novedades en Jumbo.cl" />
                <meta name="Abstract" content="Jumbo" />
                <meta name="author" content="Jumbo" />
                <meta name="copyright" content="Jumbo" />
                <meta name="country" content="CHL" />
                <meta name="theme-color" content="#008409" />
            </Helmet>
            <ErrorBoundary>
                <Routes />
            </ErrorBoundary>
        </div>

    )
}

export default productsStore.wrapProvider(App);

